<template>
    <div class="m-profile-page">
      <FeedHeader />
  
      <main class="m-profile-content">
        <section class="profile-card" @click="openSection('general')">
          <div class="avatar-wrap">
            <img :src="avatarUrl" class="avatar" alt="Avatar" />
          </div>
  
          <div class="profile-info">
            <h1>{{ userName }}</h1>
            <p>{{ userSpecifics }}</p>
          </div>
  
          <span class="profile-chevron">›</span>
        </section>
  
        <section class="completion-card">
          <div class="completion-top">
            <span>Заполненность профиля</span>
            <strong>{{ profileCompletion }}%</strong>
          </div>
  
          <div class="progress-track">
            <div
              class="progress-fill"
              :style="{ width: `${profileCompletion}%` }"
            ></div>
          </div>
        </section>

        <section class="ai-section">
          <AIBanner
            :loading="aiLoading1"
            title="Не уверен в своем резюме?"
            subtitle="Попросить помощи у нейронной сети красиво оформить твое резюме"
            @click="handleAIClick1"
          />

          <AIBanner
            :loading="aiLoading2"
            title="Лень заполнять резюме?"
            subtitle="Просто нажми и добавь свое резюме в pdf/doc формате и AI все сделает сама"
            @click="handleAIClick2"
          />
        </section>

        <AIResumeUploadModal
          v-if="showAIModal"
          @close="showAIModal = false"
        />
  
        <section class="menu-section">
          <div class="section-title">Настройки профиля</div>
  
          <button
            v-for="item in items"
            :key="item.key"
            class="menu-item"
            @click="openSection(item.key)"
          >
            <div class="item-left">
              <div class="item-icon">
                <img :src="item.icon" :alt="item.label" />
              </div>
  
              <span>{{ item.label }}</span>
            </div>
  
            <span class="chevron">›</span>
          </button>
        </section>
      </main>
  
      <MobileTabBar />
    </div>
  </template>
  
  <script setup>
  
  import { computed, ref } from "vue";
  import { useRouter } from "vue-router";
  
  import FeedHeader from "../components/FeedHeader.vue";
  import MobileTabBar from "../components/MobileTabBar2.vue";
  import AIBanner from "../components/AIBanner.vue";
  import AIResumeUploadModal from "../components/AIResumeUploadModal.vue";
  import PremiumService from "../api/PremiumService";

  const router = useRouter();
  const profile = ref(getLocalProfile());
  
  const items = [
    { key: "general", label: "Общее", icon: "/m-profile-general.png" },
    { key: "skills", label: "Проф скиллы", icon: "/m-profile-skills.png" },
    { key: "company", label: "Компания", icon: "/m-profile-company.png" },
    { key: "resume", label: "Резюме", icon: "/m-profile-resume.png" },
    { key: "social", label: "Социальные сети", icon: "/m-profile-social.png" },
    { key: "professional", label: "Профессиональные ссылки", icon: "/m-profile-professional.png" },
    { key: "premium", label: "Премиум", icon: "/m-profile-premium.png" },
    { key: "other", label: "Прочее", icon: "/m-profile-other.png" },
    { key: "account", label: "Аккаунт", icon: "/m-profile-account.png" },
  ];

  const aiLoading1 = ref(false);
  const aiLoading2 = ref(false);
  const showAIModal = ref(false);
  
  const avatarUrl = computed(() => {
    return (
      localStorage.getItem("current_user_avatar") ||
      profile.value?.image_url ||
      "/default-avatar.png"
    );
  });
  
  const userName = computed(() => {
    return profile.value?.name || "Мой профиль";
  });
  
  const userSpecifics = computed(() => {
    return profile.value?.specifics || "Настройте информацию о себе";
  });
  
  const profileCompletion = computed(() => {
    return profile.value?.totalFillingCount || 10;
  });
  
  function getLocalProfile() {
    try {
      return JSON.parse(localStorage.getItem("user_profile")) || {};
    } catch {
      return {};
    }
  }
  
  function openSection(section) {
  if (section === "general") {
    router.push("/m-profile-general");
    return;
  }

  if (section === "skills") {
    router.push("/m-profile-skills");
    return;
  }

  if (section === "company") {
    router.push("/m-profile-company");
    return;
  }


  if (section === "resume") {
    router.push("/m-profile-resume");
    return;
  }

  if (section === "social") {
    router.push("/m-profile-social");
    return;
  }

  if (section === "professional") {
    router.push("/m-profile-professional-links");
    return;
  }

  if (section === "premium") {
    router.push("/m-profile-premium");
    return;
  }

  if (section === "other") {
    router.push("/m-profile-other");
    return;
  }

  if (section === "account") {
    router.push("/m-profile-account");
    return;
  }

  router.push({
    path: "/m-profile-section",
    query: {
      section,
    },
  });
}

async function handleAIClick1() {
    aiLoading1.value = true;

    try {
      const result = await PremiumService.fillInResumePremium();

      const cached = getLocalProfile();
      cached.aboutSelf = result.text;

      localStorage.setItem("user_profile", JSON.stringify(cached));
      profile.value = cached;
    } catch (e) {
      console.error(e);
    } finally {
      aiLoading1.value = false;
    }
  }

  async function handleAIClick2() {
    aiLoading2.value = true;

    try {
      showAIModal.value = true;
    } catch (e) {
      console.error(e);
    } finally {
      aiLoading2.value = false;
    }
  }

  </script>
  
  <style scoped>
  .m-profile-page {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    background: var(--background-color);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .m-profile-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
    padding-bottom: 24px;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
  }
  
  .profile-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px;
    border-radius: 24px;
    background: var(--sidebar-background);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
    cursor: pointer;
  }
  
  .avatar-wrap {
    width: 64px;
    height: 64px;
    border-radius: 22px;
    overflow: hidden;
    flex-shrink: 0;
    background: var(--input-background);
  }
  
  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .profile-info {
    flex: 1;
    min-width: 0;
  }
  
  .profile-info h1 {
    margin: 0;
    font-family: "Eastman-Bold", sans-serif;
    font-size: 20px;
    color: var(--text-primary);
    letter-spacing: -0.5px;
  }
  
  .profile-info p {
    margin: 5px 0 0;
    font-family: "Eastman-Regular", sans-serif;
    font-size: 13px;
    color: var(--text-secondary);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .profile-chevron,
  .chevron {
    font-size: 28px;
    color: var(--text-secondary);
  }
  
  .completion-card {
    margin-top: 14px;
    padding: 16px;
    border-radius: 22px;
    background: var(--sidebar-background);
  }
  
  .completion-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: "Eastman-Medium", sans-serif;
    font-size: 13px;
    color: var(--text-primary);
    margin-bottom: 12px;
  }
  
  .completion-top strong {
    color: #2173e5;
  }
  
  .progress-track {
    height: 8px;
    border-radius: 999px;
    background: var(--input-background);
    overflow: hidden;
  }
  
  .progress-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, #2173e5, #61a4ff);
    transition: width 0.3s ease;
  }
  
  .menu-section {
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .section-title {
    font-family: "Eastman-Bold", sans-serif;
    font-size: 13px;
    color: var(--text-secondary);
    margin: 0 0 6px 6px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
  
  .menu-item {
    width: 100%;
    border: none;
    background: var(--sidebar-background);
    color: var(--text-primary);
    border-radius: 18px;
    padding: 13px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: "Eastman-Medium", sans-serif;
    font-size: 14px;
    cursor: pointer;
  }
  
  .item-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }
  
  .item-icon {
    width: 34px;
    height: 34px;
    border-radius: 12px;
    background: var(--input-background);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .item-icon img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
  
  @media (min-width: 768px) {
    .m-profile-page {
      max-width: 430px;
      margin: 0 auto;
      border-left: 1px solid var(--separator_home);
      border-right: 1px solid var(--separator_home);
    }
  }

  .ai-section {
    margin-top: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  </style>